export const CREATE_PASSWORD = 'CREATE_PASSWORD';
export const SUCCESS_CREATE_PASSWORD = 'SUCCESS_CREATE_PASSWORD';
export const FAILURE_CREATE_PASSWORD = 'FAILURE_CREATE_PASSWORD';

export const INIT_CREATE_PASSWORD = 'INIT_CREATE_PASSWORD';


// WEBPACK FOOTER //
// ./js/actions/createPassword.js